import PropTypes from "prop-types";

const SimpleRenderer = ({ label, text, url }) => {
  let innerText = text
    ? [
        text.map((line) => {
          return (
            // eslint-disable-next-line react/jsx-key
            <span>
              {line}
              <br />
            </span>
          );
        }),
        // eslint-disable-next-line react/jsx-key
        <br />,
      ]
    : undefined;
  return (
    <div>
      <strong>{label}</strong>
      <br />
      {url ? <a href={url}>{innerText}</a> : <span>{innerText}</span>}
    </div>
  );
};

SimpleRenderer.propTypes = {
  label: PropTypes.string,
  text: PropTypes.array,
  url: PropTypes.string,
};

export default SimpleRenderer;
